import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
// import PropTypes from "prop-types";

const ScrollToTop = (props) => {
  const [buttonVisible, setButtonVisible] = useState(false);
  const location = useLocation();

  const buttonStyle = {
    opacity: buttonVisible ? "1" : "0",
    pointerEvents: buttonVisible ? "all" : "none",
    transition: "0.3s",
    position: "fixed",
    zIndex: "200",
    right: "1rem",
    bottom: "1rem",
    padding: ".75rem",
  };

  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const handleScroll = () => {
    setButtonVisible(window.scrollY > 500);
  };

  useEffect(() => {
    document.documentElement.style.scrollBehavior = "auto";
    setTimeout(() => window.scrollTo(0, 0), 0);
    setTimeout(
      () => (document.documentElement.style.scrollBehavior = "smooth"),
      1
    );
  }, [location]);

  useEffect(() => {
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="position-relative">
      <Button style={buttonStyle} onClick={handleScrollToTop}>
        <i className="bi bi-arrow-up d-flex justify-content-center align-items-center" />
      </Button>
      {props.children}
    </div>
  );
};

/* required: display name */
ScrollToTop.displayName = "ScrollToTop";

/* required: props types */
ScrollToTop.propTypes = {};

/* required: default props */
ScrollToTop.defaultProps = {};

export { ScrollToTop };
